module.exports = __webpack_public_path__ + "static/team-5-c2fe597bf95e57bc0a4dd564a88c006e.png";